import React, { useEffect, useState } from "react";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
} from "react-router-dom";
import Login from "./components/auth/Login";
import Dashboard from "./components/Dashboard";
import ProtectedRoute from "./routes/ProtectedRoute";
import ImportProducts from "./components/ImportProducts";

const App = () => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const getUser = localStorage.getItem("user");
    if (getUser) {
      setUser(JSON.parse(getUser));
    } else {
      setUser(null);
    }
    setLoading(false); 
  }, []);

  if (loading) {
    return <div>Loading...</div>; 
  }
  
  return (
    <Router>
      <Routes>
        <Route
          path="/"
          element={
            <Navigate to={user ? "/dashboard/home" : "/login"} replace />
          }
        />
        <Route
          path="/login"
          element={
            user ? (
              <Navigate to="/dashboard/home" replace />
            ) : (
              <Login setUser={setUser} />
            )
          }
        />
        <Route
          path="/dashboard/*"
          element={
            <ProtectedRoute user={user}>
              <Dashboard user={user} setUser={setUser} />
            </ProtectedRoute>
          }
        />

        <Route
          path=":receivingCollection/import-products/:collectionName"
          element={<ImportProducts />}
        />
      </Routes>
    </Router>
  );
};

export default App;
